class AuthData {
    constructor(clientState) {
        Object.defineProperty(this, "clientState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.clientState = clientState;
    }
    get auth() {
        return this.clientState && this.clientState.auth;
    }
    get isLoggedIn() {
        return this.auth != null && this.clientState.action !== 'LegacyLogin';
    }
    get person() {
        return this.auth && this.auth.person;
    }
    get customer() {
        return this.auth && this.auth.customer;
    }
    get dealer() {
        return this.auth && this.auth.dealer;
    }
    get isDealer() {
        return this.dealer != null;
    }
    get personName() {
        if (this.person) {
            const { firstName, displayName = '' } = this.person;
            return firstName || displayName;
        }
    }
    get customerName() {
        if (this.customer) {
            const { displayName = '' } = this.customer;
            return displayName;
        }
    }
    get dealerName() {
        return this.dealer && this.dealer.displayName;
    }
    get displayName() {
        return this.customerName || this.personName;
    }
    get customerType() {
        if (this.customer) {
            return this.customer.type;
        }
    }
    get authLevel() {
        return this.auth ? this.auth.authLevel : 0;
    }
}
export default AuthData;
//# sourceMappingURL=AuthData.js.map